import React from 'react';
import {Iogl} from '../../../backend/model';
import {compareNumericString} from '../../../utils/sorting';
import {IogLink, IoglLink} from '../../TableItemLink';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';

const TABLE_ID = 'iogPage-ioglsTable'

const COLUMN_DEFINITIONS = [
    {
        id: 'iogId',
        header: 'IOG',
        cell: (iogl: Iogl): JSX.Element => <IogLink iogId={iogl.iogId}/>,
        sortingComparator: (a: Iogl, b: Iogl): number => compareNumericString(a.iogId, b.iogId),
    },
    {
        id: 'fcId',
        header: 'Location',
        cell: (iogl: Iogl): JSX.Element => <IoglLink iogId={iogl.iogId} fcId={iogl.fcId}/>,
        sortingField: 'fcId',
    },
    {
        id: 'inboundEnabled',
        header: 'Inbound Enabled',
        cell: (iogl: Iogl): string => iogl.inboundEnabled.toString(),
        sortingField: 'inboundEnabled'
    },
    {
        id: 'fulfillmentEnabled',
        header: 'Fulfillment Enabled',
        cell: (iogl: Iogl): string => iogl.fulfillmentEnabled.toString(),
        sortingField: 'fulfillmentEnabled'
    },
    {
        id: 'ifoId',
        header: 'IFO',
        cell: (iogl: Iogl): string => iogl.ifoId,
        sortingComparator: (a: Iogl, b: Iogl): number => compareNumericString(a.ifoId, b.ifoId),
        sortingField: 'ifoId'
    },
]

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'IOG',
        key: 'iogId',
        groupValuesLabel: 'IOG ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Location',
        key: 'fcId',
        groupValuesLabel: 'FC ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Inbound Enabled',
        key: 'inboundEnabled',
        groupValuesLabel: 'Inbound enabled values',
        operators: operators,
    },
    {
        propertyLabel: 'Fulfillment Enabled',
        key: 'fulfillmentEnabled',
        groupValuesLabel: 'Fulfillment enabled values',
        operators: operators,
    },
    {
        propertyLabel: 'IFO',
        key: 'ifoId',
        groupValuesLabel: 'IFO ID values',
        operators: operators,
    },
]

const IoglTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `At ${tableItems.length} Locations`,
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.iogId, row.fcId, row.inboundEnabled.toString(), row.fulfillmentEnabled.toString(), row.ifoId]
        }
    }
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES)
}

export default IoglTable
